/* HEFEL â€“ show country popup only to visitors outside AT and CH. */
(() => {
  const popup = document.getElementById('hefel-geo-popup');
  if (!popup) return;

  const closeButton = popup.querySelector('.hefel-geo-popup__close');
  const dialog = popup.querySelector('.hefel-geo-popup__panel');
  if (!closeButton || !dialog) return;

  const STORAGE_KEY = 'hefel_geo_popup_at_ch_v2';
  const HOME_COUNTRIES = new Set(['AT', 'CH']);
  let previousFocus = null;

  const remember = (value) => {
    try { window.localStorage.setItem(STORAGE_KEY, value); }
    catch (_) { /* Browser storage may be blocked. */ }
  };

  const alreadyAnswered = () => {
    try { return Boolean(window.localStorage.getItem(STORAGE_KEY)); }
    catch (_) { return false; }
  };

  const showPopup = () => {
    previousFocus = document.activeElement;
    popup.hidden = false;
    document.documentElement.classList.add('hefel-geo-popup-open');
    closeButton.focus({ preventScroll: true });
  };

  const hidePopup = () => {
    popup.hidden = true;
    document.documentElement.classList.remove('hefel-geo-popup-open');
    if (previousFocus && typeof previousFocus.focus === 'function') {
      previousFocus.focus({ preventScroll: true });
    }
  };

  const dismissPopup = () => {
    remember('dismissed');
    hidePopup();
  };

  popup.querySelectorAll('[data-hefel-geo-dismiss]').forEach((element) => {
    element.addEventListener('click', dismissPopup);
  });

  // Each button points to the actual HEFEL market-specific homepage.
  // Shopify resolves the storefront context through its market URL.
  popup.querySelectorAll('[data-hefel-geo-choice]').forEach((link) => {
    link.addEventListener('click', () => {
      remember(link.dataset.hefelGeoChoice);
      // Follow the native href; no custom cart/market logic is changed.
    });
  });

  document.addEventListener('keydown', (event) => {
    if (popup.hidden) return;

    if (event.key === 'Escape') {
      dismissPopup();
      return;
    }

    if (event.key !== 'Tab') return;
    const focusables = [...popup.querySelectorAll('button:not([disabled]), a[href]')];
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (!first || !last) return;

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  const currentUrl = new URL(window.location.href);
  const isTest = currentUrl.searchParams.get('hefel_geo_test') === '1';
  if (isTest) {
    currentUrl.searchParams.delete('hefel_geo_test');
    window.history.replaceState(window.history.state, '', currentUrl.href);
    showPopup();
    return;
  }

  if (alreadyAnswered()) return;
  if (window.Shopify && window.Shopify.designMode) return;

  // Shopify Ajax API: the detected country is based on IP/browser context,
  // unlike localization.country or our existing HEFEL_MARKET_MAP (URL-based).
  const routeRoot = window.Shopify?.routes?.root || '/';
  const root = routeRoot.endsWith('/') ? routeRoot : `${routeRoot}/`;
  const endpoint = `${root}browsing_context_suggestions.json?country%5Benabled%5D=true`;

  fetch(endpoint, { credentials: 'same-origin' })
    .then((response) => {
      if (!response.ok) throw new Error('Shopify geolocation request failed');
      return response.json();
    })
    .then((data) => {
      const ipCountry = data?.detected_values?.country?.handle?.toUpperCase();
      if (ipCountry && !HOME_COUNTRIES.has(ipCountry) && !alreadyAnswered()) {
        showPopup();
      }
    })
    .catch((error) => {
      // Fail open: the shop stays usable if location detection fails.
      console.warn('HEFEL geolocation unavailable:', error);
    });
})();